"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var style_1 = require("./style");
var MainSection = function (_a) {
    var rows = _a.rows;
    return (react_1.default.createElement(style_1.Wrapper, null, rows.map(function (links, idxRow) { return (react_1.default.createElement(react_1.Fragment, { key: idxRow + "-row-of-links" },
        links.map(function (_a, idxLink) {
            var label = _a.label, props = _a.props;
            return (react_1.default.createElement(react_1.Fragment, { key: idxLink + "-link" },
                react_1.default.createElement("a", __assign({ className: 'MainSection__Link' }, props), label),
                (idxLink < (links.length - 1))
                    ? (react_1.default.createElement("span", { className: 'MainSection__Splitter' }, "|"))
                    : null));
        }),
        (idxRow < (rows.length - 1))
            ? (react_1.default.createElement("br", null))
            : null)); })));
};
exports.default = MainSection;
